export default {
  street: 'owner.address.street',
  city: 'owner.address.city',
  state: 'owner.address.state',
  zip: 'owner.address.zip',
};
